import React, { useEffect, useState } from "react";

const ScheduleTable = ({ lstPeriodHdr, currentDayData }) => {
    const [dayData, setDayData] = useState({});
    const [lstPeriod, setLstPeriod] = useState([]);
    const [tchFiltered, setTchFiltered] = useState("");

    useEffect(() => {
        // console.log("ScheduleTable called");
        // console.log(" currentDayData", JSON.stringify(currentDayData, null, 2));
        // console.log("First teacher", currentDayData.lstTch && currentDayData.lstTch[0]);
        currentDayData && currentDayData.lstTch && currentDayData.lstTch.map((teacher) => {
            // console.log("Teacher ID:", teacher.tchId);
            // console.log("Teacher Name:", teacher.tch);
            // console.log("No of periods:", teacher.lstMstCell && teacher.lstMstCell.length);
        });
        // console.log(" lstPeriodHdr", JSON.stringify(lstPeriodHdr, null, 2));
        setDayData(currentDayData);
        setLstPeriod(lstPeriodHdr);
    }, [currentDayData, lstPeriodHdr]);

    const getPeriodData = (period) => {
        // console.log("getPeriodData called, period", period);
        const allocationCount = period.lstPeriod.length;
        return {
            periodCount: allocationCount,
            periodInfo: period.lstPeriod[0]
        };
    }


    const renderPeriodCell = (period) => {
        const { lstPeriod } = period; // Safely handle undefined lstPeriod
        // console.log("renderPeriodCell called, lstPeriod", lstPeriod);

        if (!lstPeriod.length) return null; // Handle empty lstPeriod


        // Helper function to render a single period with dynamic font sizes
        const renderSinglePeriod = (p, fontSizeSubject, fontSizeClass) => (
            <div>
                <div
                    style={{
                        lineHeight: "normal",
                        whiteSpace: "normal",
                        wordWrap: "break-word",
                        fontSize: `${fontSizeSubject}px`,
                        fontWeight: "bold",
                        marginTop: "10px",
                    }}
                >
                    {p?.sub || "-"}
                </div>
                <div
                    style={{
                        alignContent: "center",
                        fontSize: `${fontSizeClass}px`,
                        marginTop: "10px",
                        marginBottom: "10px",
                        textAlign: "center",
                    }}
                >
                    {p?.cls || "-"}-{p?.sec || "-"}
                </div>
            </div>
        );

        // Set font sizes based on number of partitions
        const fontSizeMap = {
            1: { subject: 14, class: 12 },
            2: { subject: 12, class: 10 },
            3: { subject: 10, class: 8 },
            4: { subject: 10, class: 8 },
            6: { subject: 8, class: 6 },
        };
        const fontSize = fontSizeMap[lstPeriod.length] || { subject: 8, class: 6 };

        // Condition 1: Only one period
        if (lstPeriod.length === 1) {
            // console.log("renderPeriodCell called, lstPeriod", lstPeriod);
            return (
                <div style={{ display: "flex", justifyContent: "center" }}>
                    {renderSinglePeriod(lstPeriod[0], fontSize.subject, fontSize.class)}
                </div>
            );
        }

        // Condition 2: Two periods with vertical partition
        if (lstPeriod.length === 2) {
            // console.log("renderPeriodCell called, lstPeriod", lstPeriod);
            return (
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                    <div style={{ flex: 1, borderRight: "1px solid #ccc", padding: "0 5px" }}>
                        {renderSinglePeriod(lstPeriod[0], fontSize.subject, fontSize.class)}
                    </div>
                    <div style={{ flex: 1, padding: "0 5px" }}>
                        {renderSinglePeriod(lstPeriod[1], fontSize.subject, fontSize.class)}
                    </div>
                </div>
            );
        }

        // Condition 4: Four periods
        if (lstPeriod.length <= 4) {
            // console.log("renderPeriodCell called, lstPeriod", lstPeriod);
            return (
                <div style={{ display: "grid", gridTemplateRows: "1fr 1fr", height: "100%" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", borderBottom: "1px solid #ccc" }}>
                        <div style={{ flex: 1, padding: "0 5px", borderRight: "1px solid #ccc" }}>
                            {renderSinglePeriod(lstPeriod[0], fontSize.subject, fontSize.class)}
                        </div>
                        <div style={{ flex: 1, padding: "0 5px" }}>
                            {renderSinglePeriod(lstPeriod[1], fontSize.subject, fontSize.class)}
                        </div>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div style={{ flex: 1, padding: "0 5px", borderRight: "1px solid #ccc" }}>
                            {renderSinglePeriod(lstPeriod[2], fontSize.subject, fontSize.class)}
                        </div>
                        <div style={{ flex: 1, padding: "0 5px" }}>
                            {lstPeriod[3] ? renderSinglePeriod(lstPeriod[3], fontSize.subject, fontSize.class) : null}
                        </div>

                    </div>
                </div>
            );
        }

        // Condition 5: More than four periods
        if (lstPeriod.length > 4) {
            return (
                <div style={{ display: "grid", gridTemplateRows: "1fr 1fr", height: "100%" }}>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", borderBottom: "1px solid #ccc" }}>
                        {lstPeriod.slice(0, 3).map((p, idx) => (
                            <div key={idx} styl table-hovere={{ padding: "0 5px", borderRight: idx < 2 ? "1px solid #ccc" : "none" }}>
                                {renderSinglePeriod(p, fontSize.subject, fontSize.class)}
                            </div>
                        ))}
                    </div>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr" }}>
                        {lstPeriod.slice(3, 6).map((p, idx) => (
                            <div key={idx} style={{ padding: "0 5px", borderRight: idx < 2 ? "1px solid #ccc" : "none" }}>
                                {renderSinglePeriod(p, fontSize.subject, fontSize.class)}
                            </div>
                        ))}
                    </div>
                </div>
            );
        }

        return null;
    };


    const filteredTeachers = (dayData && dayData.lstTch ? dayData.lstTch : [])
        .filter((teacher) => teacher.tch.toLowerCase().includes(tchFiltered.trim().toLowerCase()));

    // data abhi load nahi hui (koi period column nahi) - table hi mat dikhao,
    // warna akela filter-box poori width le leta hai
    if (!lstPeriod || lstPeriod.length === 0) {
        return null;
    }

    return (
        <div className="table-responsive">
            <table className="table table-bordered" style={{ tableLayout: "fixed", width: "100%" }}>
                <thead>
                    <tr>
                        <th style={{ width: "100px", textAlign: "center", verticalAlign: "middle" }}>
                            <input
                                type="text"
                                className="form-control inp-search"
                                style={{ textAlign: "center", margin: "0 auto" }}
                                value={tchFiltered}
                                onChange={(e) => setTchFiltered(e.target.value)}
                                placeholder="Teacher" />
                        </th>
                        {lstPeriod && lstPeriod.length ?
                            lstPeriod.map((period, idx) => (
                                <th
                                    key={period.schedulePeriodId + "_" + idx}
                                    style={{ width: "75px", textAlign: "center", verticalAlign: "middle" }}
                                >
                                    {period.period}
                                </th>
                            )) : null
                        }
                    </tr>
                </thead>
                <tbody>
                    {filteredTeachers && filteredTeachers.length ?
                        filteredTeachers.map((teacher, idx) => (
                            <tr key={teacher.tchId + "_" + idx}>
                                <td
                                    style={{
                                        width: "100px",
                                        textAlign: "center",
                                        verticalAlign: "middle",
                                    }}
                                >
                                    {teacher.tch}
                                </td>
                                {teacher.lstMstCell && teacher.lstMstCell.length ?
                                    teacher.lstMstCell.map((period, idx) => {
                                        const bgColor = !lstPeriod[idx].assignTeacher ? "#EEEEEE" : ""
                                        return (
                                            <td
                                                key={period.schedulePeriodId}
                                                style={{
                                                    width: "75px",
                                                    textAlign: "center",
                                                    verticalAlign: "middle",
                                                    whiteSpace: "normal",
                                                    wordWrap: "break-word",
                                                    height: period.length > 0 ? "auto" : "60px",
                                                    background: bgColor,
                                                    lineHeight: "normal",
                                                }}
                                            >
                                                {renderPeriodCell(period)}
                                            </td>
                                        );
                                    }) : null
                                }
                            </tr>
                        )) : null
                    }
                </tbody>
            </table>
        </div>
    );
};

export default ScheduleTable;
